<template>
    <div>
        <div class="simple-form flex col-4 label" v-if="flag">
            <div class="form-group center">
                <div class="form-label">
                    <label>供应商名称</label>
                </div>
                <div class="form-value">
                    <span>{{contranct.sndPartyName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{contranct.fstPartyHtBh}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>支付方式</label>
                </div>
                <div class="form-value">
                    <span>{{contranct.payWayName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同状态</label>
                </div>
                <div class="form-value">
                    <span v-if="contranct.confirmed" class="">履约中</span>
                    <span v-if="contranct.fullfilled" class="">履约完成</span>
                    <span v-if="contranct.checked" class="">已验收</span>
                </div>
            </div>
        </div>
        <swb-servc-order-search name="servcOrderSearch" :no="no" :isContract="true" :contractId="contractId" @showServcOrderSearch="servcOrderSearch"></swb-servc-order-search>


        <!--<swb-query-sort-area name="query_model_ctrl" ref="query_model_ctrl" :configAuto="true" :confKey="confKey" :queryHandler="queryHandler"></swb-query-sort-area>-->
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="handlePageChange" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

        <!--<div class="swb-back-row">-->
        <!--<div class="orders-list-container">-->
        <!--<table class="orders-list-panel1">-->
        <!--<colgroup>-->
        <!--<col width="450px">-->
        <!--<col width="250px">-->
        <!--<col width="150px">-->
        <!--<col width="150px">-->
        <!--<col width="100px">-->
        <!--<col width="100px">-->
        <!--</colgroup>-->
        <!--<thead class="orders-header">-->
        <!--<tr class="">-->
        <!--<th>服务信息</th>-->
        <!--<th style="text-align: left">服务商信息</th>-->
        <!--<th>金额</th>-->
        <!--<th>交易状态</th>-->
        <!--<th>交付状态</th>-->
        <!--<th>操作</th>-->
        <!--</tr>-->
        <!--</thead>-->
        <!--<tbody class="orders-body" v-if="servOrderList != null && servOrderList.length > 0" v-for="(servcOrder, index) in servOrderList">-->
        <!--<tr class="blank-row">-->
        <!--<td colspan="6"></td>-->
        <!--</tr>-->
        <!--<tr class="abstract-row">-->
        <!--<td colspan="6">-->
        <!--<div class="abstract-content">-->
        <!--<span class="mr30">订单号：<a>{{servcOrder.no}}</a></span>-->
        <!--<span class="mr30">合同单号：<a>{{servcOrder.contractNo}}</a></span>-->
        <!--<span class="mr30">交易单号：<a class="table-cell-link" @click.stop="toTradeVoucherList(servcOrder.tradeNo, servcOrder.contractId)">{{servcOrder.tradeNo}}</a></span>-->
        <!--<span class="mr30">{{servcOrder.createTime}}</span>-->
        <!--<span class="mr30" v-if="servcOrder.trackPhaseName != null">计划阶段：{{servcOrder.trackPhaseName}}</span>-->
        <!--</div>-->
        <!--<div v-if="servcOrder.proxied" class="table-tips order"></div>-->
        <!--</td>-->
        <!--</tr>-->
        <!--<tr class="info-row">-->
        <!--<td>-->
        <!--<div class="goods-info-block" style="overflow: hidden" v-if="servcOrder.itemList != null && servcOrder.itemList.length > 0" v-for="(servcOrderItem, index) in servcOrder.itemList">-->
        <!--<div class="goods-item clearfix">-->
        <!--<div class="good-img">-->
        <!--<img v-if="servcOrderItem.servcFileBrowseUrl != null" class="wh100" :src="servcOrderItem.servcFileBrowseUrl"/>-->
        <!--</div>-->
        <!--<div class="good-msg">-->
        <!--<p class="ellipsis-2 font12 align-left">-->
        <!--<span>{{servcOrderItem.title}}</span>-->
        <!--</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</td>-->
        <!--<td>-->
        <!--<div>-->
        <!--<div class="font14 align-left">{{servcOrder.servicerName}}</div>-->
        <!--<div class="font14 align-left">预约上门时间:{{servcOrder.planTime}}</div>-->

        <!--</div>-->
        <!--</td>-->
        <!--<td>-->
        <!--<div class="font-gray1">-->
        <!--<span>总额 ¥<b class="pri">{{parseFloat(servcOrder.amount).toFixed(2)}}</b></span>-->
        <!--<span v-if="checkActionPerm('view_pay_detail') && contractId == null" class="swb-btn-link" @click="resetpay(servcOrder.no)">付款明细</span>-->
        <!--</div>-->
        <!--</td>-->
        <!--<td>-->
        <!--<div class="font14 font-gray2" v-if="servcOrder.state != null">{{servcOrder.state}}</div>-->
        <!--<div class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="searchOrder(servcOrder.id)">-->
        <!--<i class="icon iconfont"></i><span>订单详情</span>-->
        <!--</div>-->
        <!--</td>-->
        <!--<td>-->
        <!--<div v-if="servcOrder.servicerShopFlag == true">{{servcOrder.servicerShopName}}</div>-->
        <!--<div class="font14 font-gray2" v-if="servcOrder.workAssignStateX != null">状态:{{workAssignStateX[servcOrder.workAssignStateX]}}</div>-->

        <!--</td>-->
        <!--<td>-->
        <!--<div class="swb-btn-link" v-if="!servcOrder.cancelled" @click="doCancalServcOrder(servcOrder.id)">-->
        <!--<span>取消</span>-->
        <!--</div>-->
        <!--<div class="swb-btn-link" v-if="checkActionPerm('initiate_complaint')" @click="complaintSave(servcOrder.id)">-->
        <!--<span>发起投诉</span>-->
        <!--</div>-->
        <!--<div class="swb-btn-link" v-if="checkActionPerm('view_after_sale_order') && servcOrder.hasAfterSafes" @click="searchAfterSale(servcOrder.no)">-->
        <!--<span>查看售后订单</span>-->
        <!--</div>-->
        <!--&lt;!&ndash;<div class="swb-btn-link" v-if="servcOrder.hasAfterSafes">-->
        <!--<span>查看售后订单</span>-->
        <!--</div>&ndash;&gt;-->
        <!--</td>-->
        <!--</tr>-->
        <!--</tbody>-->
        <!--</table>-->
        <!--</div>-->
        <!--<div class="block pagination-layout">-->
        <!--<el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    import {showRouteLayer} from "../ctrl/RouteLayer";

    import contractApi from '../../api/contract'
    import servcOrderApi from '../../api/servcOrder'

    import SwbServcOrderOperate from './ServcOrderOperate';

    Routes.add(SwbServcOrderOperate);

    import SwbAfterSaleOrderCreate from './AfterSaleOrderCreate';

    Routes.add(SwbAfterSaleOrderCreate);

    import SwbComplaintSave from '../custsvc/ComplaintSave';

    Routes.add(SwbComplaintSave);

    import SwbAfterSaleOrderList from './AfterSaleOrderList';

    Routes.add(SwbAfterSaleOrderList);

    import SwbPayVoucherList from '../payment/PayVoucherList';

    Routes.add(SwbPayVoucherList);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';

    Routes.add(SwbTradeVoucherList);

    import SwbServcOrderSearch from './ServcOrderSearch'

    Vue.regist(SwbServcOrderSearch);


//    function resetSearchConfigData(no, queryConfig) {
//        let searchConfigData = queryConfig || {};
//        if(searchConfigData != null) {
//            let searchConfigMap = searchConfigData.queryFields.toMap("code");
//            let item = searchConfigMap['no'];
//            item.value = no;
//        }
//    }

    export default {
        name: 'swb-contract-servc-order-list',
        path: '/servc/order/list-contract',
        avlActions: 'view_pay_detail|view_detail|initiate_complaint|view_after_sale_order|cancel',
        avlActionNames: '付款明细、订单详情、发起投述、查看售后订单',
        avlScopes: 'retailer',
        desc: '服务订单列表',
        helpArticleCode: 'retailer-servc-order-list-contract',
        data: function () {
            return {
                confKey: 'swb-contract-servc-order-list',
                //
                theTableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定

                servOrderList: [],
                contractId: null,
                contranct: {},
                servcOrderStateList: [],
                afterSaleSrcOrderNo: null,
                workAssignStateX: [],
                servcOrderState: null,
                no: null,
                searchDate: '',
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                flag: false,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            // --------------------查询--------------------------------
            this.fetchData();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.simple-form, [name="servcOrderSearch"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{

                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.tradeNo != null) {
                            return '<span><a class="table-cell-link" >' + row.tradeNo + '</a></span>';
                        }
                    },
                    'trackPhaseName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.trackPhaseName != null) {
                            return '<span>' + row.trackPhaseName + '</span>';
                        }
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.state != null) {
                            return '<span>' + row.state + '</span>';
                        }
                    },
                    'servicerShopName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servicerShopFlag == true) {
                            return '<span>' + row.servicerShopName + '</span>';
                        } else {
                            return '<span>' + self.workAssignStateX[row.workAssignStateX] + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, colConf) {
                        let btnList = [];
                        if(self.checkActionPerm('view_pay_detail')) {
                            btnList.push({
                                name: 'view_pay_detail',
                                text: '付款明细'
                            })
                        }
                        if(self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '订单详情'
                            })
                        }
                        if(!row.cancelled) {
                            btnList.push({
                                name: 'cancel',
                                text: '取消'
                            })
                        }
                        if(self.checkActionPerm('initiate_complaint')) {
                            btnList.push({
                                name: 'initiate_complaint',
                                text: '发起投诉'
                            })
                        }
                        if(self.checkActionPerm('view_after_sale_order') && row.hasAfterSafes) {
                            btnList.push({
                                name: 'view_after_sale_order',
                                text: '查看售后订单'
                            })
                        }
                        return btnList
                    },
                }, /* 单元格按钮点击处理函数 */ {
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toTradeVoucherList(row.tradeNo, row.contractId)
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, event) {
                        if(btnName == 'view_pay_detail') { // 付款明细
                            self.resetpay(row)
                        } else if(btnName == 'view_detail') { // 订单详情
                            self.searchOrder(row.id)
                        } else if(btnName == 'cancel') { // 取消
                            self.doCancalServcOrder(row.id)
                        } else if(btnName == 'initiate_complaint') { // 发起投诉
                            self.complaintSave(row.id)
                        } else if(btnName == 'view_after_sale_order') { // 查看售后订单
                            self.searchAfterSale(row.no)
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },

            queryHandler(queryModel){
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetGoodsOrderList();
            },
            //
            fetchData: function () {
                //----------------------分页--------------------------------
                //保持pageSize的一致性
                this.pageSize = this.pageSizes.first();
                //----------------------搜索排序----------------------------
                let no = this.$route.query.no || null;
                if(!Utils.isNoB(no)) {
                    this.no = no;
                }
                this.queryModel.filterItems.no = no;
                //----------------------查询------------------------------s

                this.contractId = this.$route.query.contractId || null;
                this.servcOrderStateList = getEnumList("servcOrderState");
                this.workAssignStateX = getEnumMap("workAssignStateX", "value2text");
                if(this.contractId != null) {
                    this.getContractById(this.contractId);
                    this.flag = true;
                } else {
                    this.flag = false;
                }
                this.getServOrderList();
            },
            servcOrderSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getServOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.contranct = result.data;
                    }
                });
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getServOrderList();
            },

            getServOrderList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.contractFlag = true;
                if(!Utils.isNoB(self.contractId)) {
                    filterItems.contractId = self.contractId;
                }
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                if(self.servcOrderState == 2) {
                    filterItems.servicerShopFlag = false;
                }
                if(!Utils.isNoB(self.afterSaleSrcOrderNo)) {
                    filterItems.afterSaleSrcOrderNo = self.afterSaleSrcOrderNo;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                servcOrderApi.getServOrderList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let servOrderList = result.data.rows;
                        //
                        self.servOrderList = servOrderList;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(servOrderList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }

            },
            searchOrder: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId,
                    }
                });
            },
            toTradeVoucherList: function (tradeNo, contractId) {
                let self = this;
                let tradeType = null;
                if(!Utils.isNoB(contractId)) {
                    tradeType = 2;
                } else {
                    tradeType = 1;
                }
                self.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        no: tradeNo,
                        tradeVoucherType: tradeType
                    }
                })
            },
            searchAfterSale: function (no) {
                this.$router.push({
                    path: SwbAfterSaleOrderList.path,
                    query: {no: no}
                })
            },
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            // 发起投诉
            complaintSave: function (orderId) {
                let subjectType = getEnumInfoWith("complaintSubjectType", "name", "ServcOrder");
                //
                this.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        orderId: orderId,
                        subjectType: subjectType.value,
                    }
                })
            },
            resetpay: function (row) {
                let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Order").value;
                let query = {srcVoucherType: srcVoucherType, srcVoucherId: row.id, srcVoucherInnerNo: row.no};
                showRouteLayer({
                    title: '付款明细',
                    query: query,
                    template: SwbPayVoucherList
                });
            },
            doCancalServcOrder: function (orderId) {
                let self = this;
                self.$prompt('请输入取消原因', '取消确认对话框', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let cancelCause = data.value;
                    //
                    let postData = {};
                    postData.orderId = orderId;
                    postData.cancelCause = cancelCause;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    servcOrderApi.doCancelGoodsOrder(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == "info") {
                            MsgBox.info("操作成功");
                            self.getServOrderList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ContractServcOrderList.vue